import { useState, useEffect, useMemo } from 'react';
import { useUser } from '@clerk/clerk-react';
import { useOrganizationContext } from '@/contexts/OrganizationContext';
import { useMeetings } from '@/hooks/useSoundstageQueries';

export function useSoundstageUpcomingBadge() {
    const { user } = useUser();
    const { currentOrganization } = useOrganizationContext();

    // Tick every 60s so the "within 10 minutes" check re-evaluates as time passes
    const [now, setNow] = useState(() => Date.now());
    useEffect(() => {
        const interval = setInterval(() => setNow(Date.now()), 60_000);
        return () => clearInterval(interval);
    }, []);

    const { data: meetings } = useMeetings({
        organizationId: currentOrganization?.id,
        userId: user?.id,
    });

    const upcomingCount = useMemo(() => {
        if (!meetings) return 0;
        const TEN_MINUTES = 10 * 60 * 1000;
        return meetings.filter(m => {
            if (m.status === 'live') return true;
            if (m.status !== 'scheduled' || !m.scheduled_start_at) return false;
            const diff = new Date(m.scheduled_start_at).getTime() - now;
            return diff >= 0 && diff <= TEN_MINUTES;
        }).length;
    }, [meetings, now]);

    const displayCount = upcomingCount > 99 ? '99+' : String(upcomingCount);
    return { upcomingCount, displayCount };
}
